export default __webpack_public_path__ + "static/slide6-mobile-e9ff4dc007dded0bcf3392dd4957e07e.png";